module.exports = __webpack_public_path__ + "img/signIn.24f89bd1.svg";